import { z } from "zod";

export const DTOLiveblocksAuthRequest = z.object({
  room: z.string().optional(),
});

export type DTOLiveblocksAuthRequest = z.infer<typeof DTOLiveblocksAuthRequest>;
